module.exports = __webpack_public_path__ + "06_face.9f799291.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/06_face.png
// module id = 2VzA
// module chunks = 0